import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 敏感词（/v1/admin/sensitive-words/**）
 */

export function listSensitiveWords(params) {
  return axios.get(`${base.url}/service/v1/admin/sensitive-words`, { params })
}

export function createSensitiveWord(data) {
  return axios.post(`${base.url}/service/v1/admin/sensitive-words`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

export function updateSensitiveWord(id, data) {
  return axios.put(`${base.url}/service/v1/admin/sensitive-words/${id}`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

export function deleteSensitiveWord(id) {
  return axios.delete(`${base.url}/service/v1/admin/sensitive-words/${id}`)
}